/** Template respondent copy defaults from default_config.respondent_framing. */
export interface TemplateRespondentFramingDefaults {
  purpose: string;
  instructions: string;
  closingMessage: string;
}

export function templateRespondentFraming(
  defaultConfig: Record<string, unknown> | null | undefined
): TemplateRespondentFramingDefaults {
  const raw = defaultConfig?.respondent_framing;
  if (!raw || typeof raw !== 'object') {
    return { purpose: '', instructions: '', closingMessage: '' };
  }
  const rf = raw as Record<string, unknown>;
  const opening = rf.opening;
  const closing = rf.closing;
  let purpose = '';
  let instructions = '';
  let closingMessage = '';
  if (opening && typeof opening === 'object') {
    const o = opening as Record<string, unknown>;
    purpose = typeof o.purpose === 'string' ? o.purpose.trim() : '';
    instructions = typeof o.instructions === 'string' ? o.instructions.trim() : '';
  }
  if (closing && typeof closing === 'object') {
    const c = closing as Record<string, unknown>;
    closingMessage = typeof c.message === 'string' ? c.message.trim() : '';
  }
  return { purpose, instructions, closingMessage };
}
